if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');

      //Product view datalayer event
      document.dispatchEvent(new CustomEvent('ProductViewed', {
        detail: {
          country: window.Shopify.country
        }
      }));
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = window.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      if (this.dataset.hasSteelSelection === 'true') {
        // Ensure selected steel product has sufficient qty available before adding skate to cart

        let hasSufficientQty = true;

        const steelSelectionEl = document.querySelector('steel-selection');
        const selectedVariant = steelSelectionEl?.selectedSteelVariant;

        if (selectedVariant?.quantity > 0 ) {
          await fetch(`${window.routes.cart_url}`, config)
            .then((response) => response.json())
            .then((cartData) => {
              const selectedSteelLineItems = cartData.items.filter(item => item.variant_id.toString() === selectedVariant.id.toString());
              const qtyOfSelectedSteelInCart = selectedSteelLineItems.reduce((total, lineItem) => total + lineItem.quantity, 0)

              const qtyToAdd = Number(formData.get('quantity'));

              if (qtyToAdd) {
                if (qtyOfSelectedSteelInCart + qtyToAdd > selectedVariant.quantity) {
                  alert(window.Resources.pdp.steel_selection.all_remaining_qty_in_cart);
                  hasSufficientQty = false;
                }
              }
            })

          if (!hasSufficientQty) {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            return;
          }
        }
      }

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          // Can be opted into to power post-add-to-cart events, like steel selection
          if (this.dataset.emitAddToCart === 'true') {
            document.dispatchEvent(new CustomEvent('AddToCart', {
              detail: {
                line_item_key: response.key,
                product: response
              }
            }));
          }

          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
